import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SurveysComponent } from '@src/app/features/surveys/surveys/surveys.component';
import { AddSurveyComponent } from '@src/app/features/surveys/add-survey/add-survey.component';
import { EditSurveyComponent } from '@src/app/features/surveys/edit-survey/edit-survey.component';
import { ViewSurveyComponent } from '@src/app/features/surveys/view-survey/view-survey.component';
import { TakeSurveyComponent } from '@src/app/features/surveys/take-survey/take-survey.component';
import { SurveySelectorComponent } from '@src/app/features/surveys/survey-selector/survey-selector.component';

const routes: Routes = [
  { path: '', component: SurveysComponent },
  { path: 'add', component: AddSurveyComponent },
  { path: 'select-survey', component: SurveySelectorComponent },
  { path: ':surveyId/edit', component: EditSurveyComponent },
  { path: ':surveyId', component: ViewSurveyComponent },
  { path: ':surveyId/take-survey', component: TakeSurveyComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveysRoutingModule { }
